// extracted by mini-css-extract-plugin
module.exports = {"genericError":"GenericError_genericError__XOuCP"};